export type Language = 'en' | 'de';

export const translations = {
  en: {
    "Column": "Column",
    "No column assigned": "No column assigned",
    "Some properties use the same column and are switched together:": "Some properties use the same column and are switched together:",
    "Change password": "Change password",
    "Current password": "Current password",
    "New password": "New password",
    "Repeat new password": "Repeat new password",
    "Password changed.": "Password changed.",
    "Close": "Close",
    "The new password must be at least 8 characters long.": "The new password must be at least 8 characters long.",
    "The passwords do not match.": "The passwords do not match.",
    "The current password is incorrect.": "The current password is incorrect.",
    "Failed to change password.": "Failed to change password.",
    "Reset password": "Reset password",
    "New password for": "New password for",
    "at least 8 characters": "at least 8 characters",
    "Password changed for": "Password changed for",
    "A user with this login already exists.": "A user with this login already exists.",
    "You cannot delete your own account.": "You cannot delete your own account.",
    "Invalid login or password": "Invalid login or password",
    "Too many failed login attempts. Please try again in 15 minutes.": "Too many failed login attempts. Please try again in 15 minutes.",
    "Server not reachable. Please try again later.": "Server not reachable. Please try again later.",
    "Lock types": "Lock Types",
    "Lock properties": "Lock Properties",
    "System options": "System Options",
    "Supplier Icon": "Suppliers",
    "Database preview": "Database Preview",
    "Backups": "Backups",
    "Tax change": "VAT Rate",
    "Database update": "CSV Import",
    "Users": "Users",
    "Carts": "Carts",
    "Total Carts": "Total Carts",
    "Ordered": "Ordered",
    "Inquiries": "Inquiries",
    "Abandoned": "Abandoned",
    "Conversion Rate": "Conversion Rate",
    "Bestellquote": "Order rate",
    "Bestellungen + Anfragen": "Orders + Inquiries",
    "Porzucone": "abandoned",
    "Wszystkie": "all",
    "All": "All",
    "Search by Order ID, system, customer...": "Search by Order ID, system, customer...",
    "Order-ID": "Order-ID",
    "Status": "Status",
    "System / Supplier": "System / Supplier",
    "Cylinders & Keys": "Cylinders & Keys",
    "Customer": "Customer",
    "Created at": "Created at",
    "Anonymous": "Anonymous",
    "Türen": "doors",
    "Zylinder": "cylinders",
    "Schlüssel": "keys",
    "Stk.": "pcs",
    "Pozycji:": "Items:",
    "Strona": "Page",
    "z": "of",
    "Cart details": "Cart details",
    "Doors": "Doors",
    "Keys": "Keys",
    "Access permissions": "Access permissions",
    "Customer comments": "Customer comments",
    "Lieferant": "Supplier",
    "Modell": "Model",
    "Erstellt am": "Created at",
    "Bestellt am": "Ordered at",
    "Anfrage am": "Inquiry at",
    "Name": "Name",
    "Firma": "Company",
    "Email": "Email",
    "Telefon": "Phone",
    "Adresse": "Address",
    "Bezeichnung": "Name",
    "Typ": "Type",
    "Menge": "Amount",
    "Außenmaß": "Outside",
    "Innenmaß": "Inside",
    "Tür": "Door",
    "Keine Kundendaten (Warenkorb noch nicht abgesendet)": "No customer data (cart not yet submitted)",
    "Statystyki koszyków i zamówień": "Cart and order statistics",
    "Status updated successfully!": "Status updated successfully!",
    "Cart deleted successfully!": "Cart deleted successfully!",
    "Are you sure you want to delete this cart?": "Are you sure you want to delete this cart?",
    "No carts found matching your criteria.": "No carts found matching your criteria.",
    "Failed to load carts": "Failed to load carts",
    "Failed to update cart status": "Failed to update cart status",
    "Failed to delete cart": "Failed to delete cart",
    "Dashboard": "Dashboard",
    "Total Net": "Total Net",
    "Total Gross": "Total Gross",
    "Net (€)": "Net (€)",
    "Gross (€)": "Gross (€)",
    "Avg Net (€)": "Avg Net (€)",
    "Share by Supplier": "Share by Supplier",
    "Top Systems": "Top Systems",
    "Configurations over Time": "Configurations over Time",
    "Net Value by Supplier (€)": "Net Value by Supplier (€)",
    "Suppliers — Detail": "Suppliers — Detail",
    "Individual Configurations": "Individual Configurations",
    "Count": "Count",
    "Share": "Share",
    "Supplier": "Supplier",
    "System": "System",
    "Pos.": "Pos.",
    "Order type": "Order type",
    "Year": "Year",
    "Date": "Date",
    "All order types — click card to filter": "All order types — click card to filter",
    "Filtered: {status} — click again for all": "Filtered: {status} — click again for all",
    "All Suppliers": "All Suppliers",
    "All Systems": "All Systems",
    "Filter by Supplier": "Supplier",
    "Filter by System": "System / Product",
    "Time Period": "Time Period",
    "All Time": "All Time",
    "Today": "Today",
    "This Month": "This Month",
    "Last Month": "Last Month",
    "This Year": "This Year",
    "Specific Day": "Specific Day",
    "Specific Month": "Specific Month",
    "Date Range": "Date Range",
    "Select Day": "Select Day",
    "Select Month": "Select Month",
    "From": "From",
    "To": "To",
    "Reset Filters": "Reset Filters",
    "View Mode": "View Mode",
    "Dashboard & Table": "Dashboard & Table",
    "Dashboard Only": "Dashboard Only",
    "Table Only": "Table Only",
    "Sold": "Sold",
    "Entries": "Entries",
    "Menu": "Menu",
    "Logout": "Logout",
    "Admin-Panel": "Admin Panel",
    "Konfigurator": "Configurator",
    "Daten": "Data",
    "Verwaltung": "Administration",
    "Zum Konfigurator": "Open configurator",
    "Sprache": "Language",
    "Zarządzanie Użytkownikami": "Users",
    "Dodaj użytkownika": "Add User",
    "Anuluj": "Cancel",
    "Użytkownicy": "Users",
    "Role i Uprawnienia": "Roles & Permissions",
    "The admin role always has all permissions.": "The admin role always has all permissions.",
    "locked": "locked",
    "your account": "your account",
    "Login": "Username",
    "Hasło": "Password",
    "Zapisz": "Save",
    "Nie udało się pobrać użytkowników": "Failed to fetch users",
    "Nie udało się dodać użytkownika": "Failed to add user",
    "Nie udało się usunąć użytkownika": "Failed to delete user",
    "Nie udało się pobrać ról": "Failed to fetch roles",
    "Nie udało się zaktualizować uprawnień": "Failed to update permissions",
    "Nie można usunąć głównego konta admina": "Cannot delete main admin account",
    "Ładowanie...": "Loading...",
    "Rola": "Role",
    "Uprawnienia": "Permissions",
    "Użytkownik": "User",
    "Data utworzenia": "Creation Date",
    "Akcje": "Actions",
    "Usuń": "Delete",
    "Pobierz": "Download",
    "Brak uprawnień do tego widoku": "No permission for this view",
    "Choose view from the menu": "Choose view from the menu",
    "Backup created successfully!": "Backup created successfully!",
    "Failed to create backup": "Failed to create backup",
    "Are you sure you want to restore this backup? All current data will be overwritten!": "Are you sure you want to restore this backup? All current data will be overwritten!",
    "Database successfully restored!": "Database successfully restored!",
    "Failed to restore backup": "Failed to restore backup",
    "Are you sure you want to delete this backup?": "Are you sure you want to delete this backup?",
    "Backup deleted successfully!": "Backup deleted successfully!",
    "Failed to delete backup": "Failed to delete backup",
    "Failed to download backup": "Failed to download backup",
    "Create, restore, and manage database backups": "Create, restore, and manage database backups",
    "Creating...": "Creating...",
    "Backup SQLite": "Create backup",
    "No backups found. Create your first backup using the buttons above.": "No backups yet. Create the first one with the button above.",
    "Size": "Size",
    "Created by": "Created by",
    "Selected": "Selected",
    "Restoring...": "Restoring...",
    "/backups": "/backups",
    "Failed to load backups": "Failed to load backups",
    "a": "a",
    "Please select a backup from the list to restore.": "Please select a backup from the list to restore.",
    "Restore Selected Backup": "Restore Selected Backup",
    "/database/tables": "/database/tables",
    "Failed to load database tables": "Failed to load database tables",
    "Failed to load table data": "Failed to load table data",
    "Cannot edit row: missing first-column primary value": "Cannot edit row: missing first-column primary value",
    "Failed to update cell": "Failed to update cell",
    "Cannot delete row: missing primary identifier": "Cannot delete row: missing primary identifier",
    "Are you sure you want to delete this row?": "Are you sure you want to delete this row?",
    "Failed to delete row": "Failed to delete row",
    "Failed to clear table": "Failed to clear table",
    "Failed to export CSV. Make sure you are logged in.": "Failed to export CSV. Make sure you are logged in.",
    "Failed to save row": "Failed to save row",
    "Loading table data...": "Loading table data...",
    "No data available in this table": "No data available in this table",
    "Actions": "Actions",
    "Edit": "Edit",
    "Double-click to edit": "Double-click to edit",
    "Save": "Save",
    "Cancel": "Cancel",
    "Delete row": "Delete row",
    "Delete": "Delete",
    "Prev": "Prev",
    "Showing": "Showing",
    "of": "of",
    "Next": "Next",
    "rows on this page — total": "rows on this page — total",
    "Export to CSV": "Export to CSV",
    "Clear Table": "Clear Table",
    "Database Preview & Edit": "Database Preview",
    "Empty columns hidden:": "Empty columns hidden:",
    "Empty columns shown:": "Empty columns shown:",
    "Show": "Show",
    "Hide": "Hide",
    "View and edit database tables. Double-click any cell to edit its value.": "View and edit database tables. Double-click any cell to edit its value.",
    "Analyzing file": "Analyzing file",
    "Failed to upload CSV file": "Failed to upload CSV file",
    "Please select a table and upload a CSV file first.": "Please select a table and upload a CSV file first.",
    "Please map at least one column before importing.": "Please map at least one column before importing.",
    "Importing data...": "Importing data...",
    "Failed to import CSV data": "Failed to import CSV data",
    "Database Import from CSV": "CSV Import",
    "Import and update database tables from CSV files with column mapping.": "Import and update database tables from CSV files with column mapping.",
    "Processing...": "Processing...",
    "Upload CSV": "Upload CSV",
    "Target Table": "Target Table",
    "CSV Separator": "CSV Separator",
    "Comma (,)": "Comma (,)",
    "Semicolon (;)": "Semicolon (;)",
    "Tab": "Tab",
    "Pipe (|)": "Pipe (|)",
    "Upsert Match Column (Optional)": "Upsert Match Column (Optional)",
    "If selected, existing records with matching value in this column will be updated instead of inserted.": "If selected, existing records with matching value in this column will be updated instead of inserted.",
    "-- No Match (Always Insert) --": "-- No Match (Always Insert) --",
    "Column Mapping": "Column Mapping",
    "Map CSV columns to database columns": "Map CSV columns to database columns",
    "-- Skip Column --": "-- Skip Column --",
    "Current Data (top). New values appear in the panel below.": "Current Data (top). New values appear in the panel below.",
    "Hide new values panel": "Hide new values panel",
    "Show new values panel": "Show new values panel",
    "New Values (CSV) — differences highlighted": "New Values (CSV) — differences highlighted",
    "Importing...": "Importing...",
    "Import": "Import",
    "/supplier-icons/suppliers": "/supplier-icons/suppliers",
    "Failed to load suppliers": "Failed to load suppliers",
    "/supplier-icons/icons": "/supplier-icons/icons",
    "Failed to save icon": "Failed to save icon",
    "Failed to upload icon": "Failed to upload icon",
    "Are you sure you want to delete this supplier icon?": "Are you sure you want to delete this supplier icon?",
    "Failed to delete icon": "Failed to delete icon",
    "Loading suppliers...": "Loading suppliers...",
    "Supplier Icons": "Supplier Icons",
    "Assign icons to each supplier": "Assign icons to each supplier",
    "Select icon...": "Select icon...",
    "No icon": "No icon",
    "Change Icon": "Change Icon",
    "Add Icon": "Add Icon",
    "Delete Icon": "Delete Icon",
    "/lock-properties": "/lock-properties",
    "Failed to load lock properties": "Failed to load lock properties",
    "/lock-properties/icons": "/lock-properties/icons",
    "/system-options/available-columns": "/system-options/available-columns",
    "Cannot delete icon. It is still used by:": "Cannot delete icon. It is still used by:",
    "Maximum": "Maximum",
    "active properties allowed!": "active properties allowed!",
    "Failed to save property": "Failed to save property",
    "New Property": "New Property",
    "Failed to add lock property": "Failed to add lock property",
    "Are you sure you want to delete this property?": "Are you sure you want to delete this property?",
    "Failed to delete lock property": "Failed to delete lock property",
    "Loading...": "Loading...",
    "Lock Properties Management": "Lock Properties",
    "Active properties:": "Active properties:",
    "(displayed on page 2)": "(displayed on page 2)",
    "Add Property": "Add Property",
    "Name:": "Name:",
    "Property name": "Property name",
    "Property Code:": "Property Code:",
    "-- Select Property Code --": "-- Select Property Code --",
    "Unique identifier for this property": "Unique identifier for this property",
    "Description:": "Description:",
    "Description shown to users": "Description shown to users",
    "Icon:": "Icon:",
    "-- Select Icon --": "-- Select Icon --",
    "Uploading...": "Uploading...",
    "Upload New": "Upload New",
    "Available Icons:": "Available Icons:",
    "Icon preview": "Icon preview",
    "Code:": "Code:",
    "Active": "Active",
    "Inactive": "Inactive",
    "Icon uploaded successfully!": "Icon uploaded successfully!",
    "/lock-types/available": "/lock-types/available",
    "/lock-types": "/lock-types",
    "Failed to load lock types": "Failed to load lock types",
    "/lock-types/icons": "/lock-types/icons",
    "Icon uploaded successfully": "Icon uploaded successfully",
    "Icon": "Icon",
    "deleted successfully": "deleted successfully",
    "Failed to add lock type": "Failed to add lock type",
    "Error": "Error",
    "Are you sure you want to delete this lock type?": "Are you sure you want to delete this lock type?",
    "Failed to delete lock type": "Failed to delete lock type",
    "Changes saved successfully!": "Changes saved successfully!",
    "Failed to save lock types": "Failed to save lock types",
    "Error: Failed to save lock types": "Error: Failed to save lock types",
    "Lock Types Management": "Lock Types",
    "Available Types from Database (click to add):": "Available Types from Database (click to add):",
    "No lock types configured yet. Add types from the list above.": "No lock types configured yet. Add types from the list above.",
    "Type Code (from database):": "Type Code (from database):",
    "Display Name:": "Display Name:",
    "Display name (e.g., Doppelzylinder)": "Display name (e.g., Doppelzylinder)",
    "/": "/",
    "/suppliers": "/suppliers",
    "Failed to save supplier": "Failed to save supplier",
    "New Supplier": "New Supplier",
    "Failed to add supplier": "Failed to add supplier",
    "Are you sure you want to delete this supplier?": "Are you sure you want to delete this supplier?",
    "Failed to delete supplier": "Failed to delete supplier",
    "Supplier Management": "Suppliers",
    "Active suppliers:": "Active suppliers:",
    "(displayed on pages 2, 3, and 4)": "(displayed on pages 2, 3, and 4)",
    "Add Supplier": "Add Supplier",
    "Supplier name": "Supplier name",
    "Configuration saved successfully!": "Configuration saved successfully!",
    "Failed to save configuration": "Failed to save configuration",
    "System Options Mapping": "System Options",
    "Configure which lock properties are enabled for each system": "Configure which lock properties are enabled for each system",
    "Systems": "Systems",
    "Save Configuration": "Save Configuration",
    "Enabled": "Enabled",
    "Disabled": "Disabled",
    "Select a system from the list to configure its options": "Select a system from the list to configure its options",
    "/system-options": "/system-options",
    "Failed to load current tax rate": "Failed to load current tax rate",
    "Please enter a valid number.": "Please enter a valid number.",
    "Tax rate must be between 0 and 100.": "Tax rate must be between 0 and 100.",
    "New rate is the same as current rate.": "New rate is the same as current rate.",
    "Tax rate successfully updated to": "Tax rate successfully updated to",
    "Failed to update tax rate": "Failed to update tax rate",
    "Loading tax rate...": "Loading tax rate...",
    "Tax Rate Management": "VAT Rate",
    "Manage the global VAT/tax rate applied in the configurator.": "Manage the global VAT/tax rate applied in the configurator.",
    "Current Tax Rate": "Current Tax Rate",
    "New Tax Rate (%)": "New Tax Rate (%)",
    "e.g. 23": "e.g. 23",
    "Updating...": "Updating...",
    "Update Tax Rate": "Update Tax Rate",
    "/tax-rate": "/tax-rate",
    "/users": "/users",
    "/roles": "/roles",
    // Komunikaty i okno potwierdzenia (DialogContext.tsx)
    "Please confirm": "Please confirm",
    "OK": "OK",
    "Restore": "Restore",
    // CSV-Import: obszar upuszczania pliku
    "Drop a CSV file here or click to choose one": "Drop a CSV file here or click to choose one",
    "Drop another CSV file here or click to replace it": "Drop another CSV file here or click to replace it",
    "Release to upload the file": "Release to upload the file",
    "Only .csv files can be imported.": "Only .csv files can be imported.",
    "Choose the target table first - CSV columns are matched to its columns.": "Choose the target table first - CSV columns are matched to its columns.",
    "File": "File",
    // Pełne zdania z miejscami na wartości (tf w LanguageContext) - zamiast sklejanych kawałków
    "{count} row": "{count} row",
    "{count} rows": "{count} rows",
    "Are you sure you want to import {rows} into table \"{table}\"? This cannot be undone.": "Are you sure you want to import {rows} into table \"{table}\"? This cannot be undone.",
    "Import {rows}": "Import {rows}",
    "{rows} imported successfully!": "{rows} imported successfully!",
    "File analyzed successfully. {rows} found.": "File analyzed successfully. {rows} found.",
    "Permanently delete all data from table \"{table}\"? This cannot be undone.": "Permanently delete all data from table \"{table}\"? This cannot be undone.",
    "Are you sure you want to delete the icon \"{name}\"?": "Are you sure you want to delete the icon \"{name}\"?",
    "Are you sure you want to change the tax rate from {from}% to {to}%?": "Are you sure you want to change the tax rate from {from}% to {to}%?",
    "Are you sure you want to delete the user \"{name}\"?": "Are you sure you want to delete the user \"{name}\"?",
    "Mail delivery": "Mail delivery",
    "Details": "Details",
    "Failed to load mail status": "Failed to load mail status",
    "Send a test email to {to}?": "Send a test email to {to}?",
    "Send test email": "Send test email",
    "Test email sent to {to}.": "Test email sent to {to}.",
    "Test email failed": "Test email failed",
    "Emails with orders and inquiries from the configurator.": "Emails with orders and inquiries from the configurator.",
    "Transport": "Transport",
    "Sender": "Sender",
    "Test recipient": "Test recipient",
    "Test mode: emails to customers go to this address, internal emails go to their recipient with [TEST] in the subject.": "Test mode: emails to customers go to this address, internal emails go to their recipient with [TEST] in the subject.",
    "Reminders to": "Reminders to",
    "Sign-in": "Sign-in",
    "Certificate": "Certificate",
    "Client secret": "Client secret",
    "configured": "configured",
    "not configured": "not configured",
    "Valid until": "Valid until",
    "{days} days left": "{days} days left",
    "Sending...": "Sending...",
    "The test email goes to {to}.": "The test email goes to {to}.",
    "Test emails are only available with Microsoft Graph.": "Test emails are only available with Microsoft Graph.",
    "Microsoft Graph (sendMail)": "Microsoft Graph (sendMail)",
    "SMTP (old account)": "SMTP (old account)",
    "Outbox - saved as file, not sent": "Outbox - saved as file, not sent",
    "Backup partly failed": "Backup partly failed",
    "Are you sure you want to restore this MongoDB backup? All current configurations and carts will be overwritten!": "Are you sure you want to restore this MongoDB backup? All current configurations and carts will be overwritten!",
    "SQLite: prices and panel data · MongoDB: configurations and carts": "SQLite: prices and panel data · MongoDB: configurations and carts",
    "Create backup": "Create backup"
},
  de: {
    "Column": "Spalte",
    "No column assigned": "Keine Spalte zugeordnet",
    "Some properties use the same column and are switched together:": "Einige Eigenschaften nutzen dieselbe Spalte und werden gemeinsam umgeschaltet:",
    "Change password": "Passwort ändern",
    "Current password": "Aktuelles Passwort",
    "New password": "Neues Passwort",
    "Repeat new password": "Neues Passwort wiederholen",
    "Password changed.": "Das Passwort wurde geändert.",
    "Close": "Schließen",
    "The new password must be at least 8 characters long.": "Das neue Passwort muss mindestens 8 Zeichen lang sein.",
    "The passwords do not match.": "Die Passwörter stimmen nicht überein.",
    "The current password is incorrect.": "Das aktuelle Passwort ist falsch.",
    "Failed to change password.": "Das Passwort konnte nicht geändert werden.",
    "Reset password": "Passwort zurücksetzen",
    "New password for": "Neues Passwort für",
    "at least 8 characters": "mindestens 8 Zeichen",
    "Password changed for": "Passwort geändert für",
    "A user with this login already exists.": "Ein Benutzer mit diesem Login existiert bereits.",
    "You cannot delete your own account.": "Das eigene Konto kann nicht gelöscht werden.",
    "Invalid login or password": "Login oder Passwort ist falsch",
    "Too many failed login attempts. Please try again in 15 minutes.": "Zu viele fehlgeschlagene Anmeldeversuche. Bitte versuchen Sie es in 15 Minuten erneut.",
    "Server not reachable. Please try again later.": "Server nicht erreichbar. Bitte versuchen Sie es später erneut.",
    "Lock types": "Zylindertypen",
    "Lock properties": "Eigenschaften",
    "System options": "Systemzuordnung",
    "Supplier Icon": "Lieferanten",
    "Database preview": "Datenbank-Vorschau",
    "Backups": "Sicherungen",
    "Tax change": "MwSt.-Satz",
    "Database update": "CSV-Import",
    "Users": "Benutzer",
    "Carts": "Warenkörbe",
    "Total Carts": "Warenkörbe gesamt",
    "Ordered": "Bestellt",
    "Inquiries": "Anfragen",
    "Abandoned": "Abgebrochen",
    "Conversion Rate": "Konversionsrate",
    "Bestellquote": "Bestellquote",
    "Bestellungen + Anfragen": "Bestellungen + Anfragen",
    "Porzucone": "abgebrochen",
    "Wszystkie": "gesamt",
    "All": "Alle",
    "Search by Order ID, system, customer...": "Nach Auftrags-ID, System, Kunde suchen...",
    "Order-ID": "Auftrags-ID",
    "Status": "Status",
    "System / Supplier": "System / Lieferant",
    "Cylinders & Keys": "Zylinder & Schlüssel",
    "Customer": "Kunde",
    "Created at": "Erstellt am",
    "Anonymous": "Anonym",
    "Türen": "Türen",
    "Zylinder": "Zylinder",
    "Schlüssel": "Schlüssel",
    "Stk.": "Stk.",
    "Pozycji:": "Einträge:",
    "Strona": "Seite",
    "z": "von",
    "Cart details": "Warenkorb-Details",
    "Doors": "Türen / Zylinder",
    "Keys": "Schlüssel",
    "Access permissions": "Schließberechtigungen",
    "Customer comments": "Kundenhinweise",
    "Lieferant": "Lieferant",
    "Modell": "Modell",
    "Erstellt am": "Erstellt am",
    "Bestellt am": "Bestellt am",
    "Anfrage am": "Anfrage am",
    "Name": "Name",
    "Firma": "Firma",
    "Email": "E-Mail",
    "Telefon": "Telefon",
    "Adresse": "Adresse",
    "Bezeichnung": "Bezeichnung",
    "Typ": "Typ",
    "Menge": "Menge",
    "Außenmaß": "Außenmaß",
    "Innenmaß": "Innenmaß",
    "Tür": "Tür",
    "Keine Kundendaten (Warenkorb noch nicht abgesendet)": "Keine Kundendaten (Warenkorb noch nicht abgesendet)",
    "Statystyki koszyków i zamówień": "Statistiken zu Warenkörben und Bestellungen",
    "Status updated successfully!": "Status erfolgreich aktualisiert!",
    "Cart deleted successfully!": "Warenkorb erfolgreich gelöscht!",
    "Are you sure you want to delete this cart?": "Möchten Sie diesen Warenkorb wirklich löschen?",
    "No carts found matching your criteria.": "Keine Warenkörbe für die gewählten Kriterien gefunden.",
    "Failed to load carts": "Fehler beim Laden der Warenkörbe",
    "Failed to update cart status": "Fehler beim Aktualisieren des Status",
    "Failed to delete cart": "Fehler beim Löschen des Warenkorbs",
    "Dashboard": "Dashboard",
    "Total Net": "Gesamt netto",
    "Total Gross": "Gesamt brutto",
    "Net (€)": "Netto (€)",
    "Gross (€)": "Brutto (€)",
    "Avg Net (€)": "Ø Netto (€)",
    "Share by Supplier": "Anteil nach Lieferant",
    "Top Systems": "Top-Systeme (Anzahl)",
    "Configurations over Time": "Konfigurationen im Zeitverlauf",
    "Net Value by Supplier (€)": "Nettowert nach Lieferant (€)",
    "Suppliers — Detail": "Lieferanten — Detail",
    "Individual Configurations": "Einzelne Konfigurationen",
    "Count": "Anzahl",
    "Share": "Anteil",
    "Supplier": "Lieferant",
    "System": "System",
    "Pos.": "Pos.",
    "Order type": "Auftragsart",
    "Year": "Jahr",
    "Date": "Datum",
    "All order types — click card to filter": "Alle Auftragsarten — Karte anklicken zum Filtern",
    "Filtered: {status} — click again for all": "Gefiltert: {status} — noch einmal klicken für alle",
    "All Suppliers": "Alle Lieferanten",
    "All Systems": "Alle Systeme",
    "Filter by Supplier": "Lieferant",
    "Filter by System": "System / Produkt",
    "Time Period": "Zeitraum",
    "All Time": "Gesamter Zeitraum",
    "Today": "Heute",
    "This Month": "Dieser Monat",
    "Last Month": "Letzter Monat",
    "This Year": "Dieses Jahr",
    "Specific Day": "Konkreter Tag",
    "Specific Month": "Konkreter Monat",
    "Date Range": "Datumsbereich",
    "Select Day": "Tag wählen",
    "Select Month": "Monat wählen",
    "From": "Von",
    "To": "Bis",
    "Reset Filters": "Filter zurücksetzen",
    "View Mode": "Ansicht",
    "Dashboard & Table": "Dashboard & Tabelle",
    "Dashboard Only": "Nur Dashboard",
    "Table Only": "Nur Tabelle",
    "Sold": "Verkauft",
    "Entries": "Einträge",
    "Menu": "Menü",
    "Logout": "Abmelden",
    "Admin-Panel": "Admin-Panel",
    "Konfigurator": "Konfigurator",
    "Daten": "Daten",
    "Verwaltung": "Verwaltung",
    "Zum Konfigurator": "Zum Konfigurator",
    "Sprache": "Sprache",
    "Zarządzanie Użytkownikami": "Benutzer",
    "Dodaj użytkownika": "Anwender hinzufügen",
    "Anuluj": "Abbrechen",
    "Użytkownicy": "Anwender",
    "Role i Uprawnienia": "Rollen & Berechtigungen",
    "The admin role always has all permissions.": "Die Rolle admin hat immer alle Berechtigungen.",
    "locked": "gesperrt",
    "your account": "Ihr Konto",
    "Login": "Benutzername",
    "Hasło": "Passwort",
    "Zapisz": "Speichern",
    "Nie udało się pobrać użytkowników": "Fehler beim Abrufen der Benutzer",
    "Nie udało się dodać użytkownika": "Fehler beim Hinzufügen des Benutzers",
    "Nie udało się usunąć użytkownika": "Fehler beim Löschen des Benutzers",
    "Nie udało się pobrać ról": "Fehler beim Abrufen der Rollen",
    "Nie udało się zaktualizować uprawnień": "Fehler beim Aktualisieren der Berechtigungen",
    "Nie można usunąć głównego konta admina": "Das Haupt-Admin-Konto kann nicht gelöscht werden",
    "Ładowanie...": "Wird geladen...",
    "Rola": "Rolle",
    "Uprawnienia": "Berechtigungen",
    "Użytkownik": "Benutzer",
    "Data utworzenia": "Erstellungsdatum",
    "Akcje": "Aktionen",
    "Usuń": "Löschen",
    "Pobierz": "Herunterladen",
    "Brak uprawnień do tego widoku": "Keine Berechtigung für diese Ansicht",
    "Choose view from the menu": "Wählen Sie eine Ansicht aus dem Menü",
    "Backup created successfully!": "Backup erfolgreich erstellt!",
    "Failed to create backup": "Backup konnte nicht erstellt werden",
    "Are you sure you want to restore this backup? All current data will be overwritten!": "Sind Sie sicher, dass Sie dieses Backup wiederherstellen möchten? Alle aktuellen Daten werden überschrieben!",
    "Database successfully restored!": "Datenbank erfolgreich wiederhergestellt!",
    "Failed to restore backup": "Fehler beim Wiederherstellen des Backups",
    "Are you sure you want to delete this backup?": "Sind Sie sicher, dass Sie dieses Backup löschen möchten?",
    "Backup deleted successfully!": "Backup erfolgreich gelöscht!",
    "Failed to delete backup": "Fehler beim Löschen des Backups",
    "Failed to download backup": "Fehler beim Herunterladen des Backups",
    "Create, restore, and manage database backups": "Erstellen, wiederherstellen und verwalten von Datenbank-Backups",
    "Creating...": "Wird erstellt...",
    "Backup SQLite": "Sicherung erstellen",
    "No backups found. Create your first backup using the buttons above.": "Noch keine Sicherungen. Erstellen Sie die erste mit der Schaltfläche oben.",
    "Size": "Größe",
    "Created by": "Erstellt von",
    "Selected": "Ausgewählt",
    "Restoring...": "Wiederherstellen...",
    "/backups": "/backups",
    "Failed to load backups": "Backups konnten nicht geladen werden",
    "a": "a",
    "Please select a backup from the list to restore.": "Bitte wählen Sie ein Backup aus der Liste zum Wiederherstellen aus.",
    "Restore Selected Backup": "Ausgewähltes Backup wiederherstellen",
    "/database/tables": "/database/tables",
    "Failed to load database tables": "Fehler beim Laden der Datenbanktabellen",
    "Failed to load table data": "Fehler beim Laden der Tabellendaten",
    "Cannot edit row: missing first-column primary value": "Zeile kann nicht bearbeitet werden: primärer Wert der ersten Spalte fehlt",
    "Failed to update cell": "Zelle konnte nicht aktualisiert werden",
    "Cannot delete row: missing primary identifier": "Zeile kann nicht gelöscht werden: fehlende primäre Kennung",
    "Are you sure you want to delete this row?": "Sind Sie sicher, dass Sie diese Zeile löschen möchten?",
    "Failed to delete row": "Fehler beim Löschen der Zeile",
    "Failed to clear table": "Fehler beim Leeren der Tabelle",
    "Failed to export CSV. Make sure you are logged in.": "CSV-Export fehlgeschlagen. Melden Sie sich an.",
    "Failed to save row": "Fehler beim Speichern der Zeile",
    "Loading table data...": "Tabellendaten werden geladen...",
    "No data available in this table": "Keine Daten in dieser Tabelle verfügbar",
    "Actions": "Aktionen",
    "Edit": "Bearbeiten",
    "Double-click to edit": "Doppelklick zum Bearbeiten",
    "Save": "Speichern",
    "Cancel": "Abbrechen",
    "Delete row": "Zeile löschen",
    "Delete": "Löschen",
    "Prev": "Zurück",
    "Showing": "Zeige",
    "of": "von",
    "Next": "Weiter",
    "rows on this page — total": "Zeilen auf dieser Seite — gesamt",
    "Export to CSV": "Als CSV exportieren",
    "Clear Table": "Tabelle leeren",
    "Database Preview & Edit": "Datenbank-Vorschau",
    "Empty columns hidden:": "Leere Spalten ausgeblendet:",
    "Empty columns shown:": "Leere Spalten eingeblendet:",
    "Show": "Anzeigen",
    "Hide": "Ausblenden",
    "View and edit database tables. Double-click any cell to edit its value.": "Datenbanktabellen anzeigen und bearbeiten. Doppelklick auf eine Zelle, um ihren Wert zu bearbeiten.",
    "Analyzing file": "Datei wird analysiert",
    "Failed to upload CSV file": "Fehler beim Hochladen der CSV-Datei",
    "Please select a table and upload a CSV file first.": "Bitte wählen Sie eine Tabelle aus und laden Sie zuerst eine CSV-Datei hoch.",
    "Please map at least one column before importing.": "Bitte ordnen Sie vor dem Import mindestens eine Spalte zu.",
    "Importing data...": "Daten werden importiert...",
    "Failed to import CSV data": "Fehler beim Importieren der CSV-Daten",
    "Database Import from CSV": "CSV-Import",
    "Import and update database tables from CSV files with column mapping.": "Tabellen aus CSV-Dateien importieren und aktualisieren mit Spaltenzuordnung.",
    "Processing...": "Verarbeitung...",
    "Upload CSV": "CSV hochladen",
    "Target Table": "Zieltabelle",
    "CSV Separator": "CSV-Trennzeichen",
    "Comma (,)": "Komma (,)",
    "Semicolon (;)": "Semikolon (;)",
    "Tab": "Tabulator",
    "Pipe (|)": "Pipe (|)",
    "Upsert Match Column (Optional)": "Upsert-Übereinstimmungsspalte (Optional)",
    "If selected, existing records with matching value in this column will be updated instead of inserted.": "Wenn ausgewählt, werden vorhandene Datensätze mit übereinstimmendem Wert aktualisiert anstatt eingefügt.",
    "-- No Match (Always Insert) --": "-- Keine Übereinstimmung (Immer einfügen) --",
    "Column Mapping": "Spaltenzuordnung",
    "Map CSV columns to database columns": "CSV-Spalten Datenbankspalten zuordnen",
    "-- Skip Column --": "-- Spalte überspringen --",
    "Current Data (top). New values appear in the panel below.": "Aktuelle Daten (oben). Neue Werte (unten).",
    "Hide new values panel": "Panel mit neuen Werten ausblenden",
    "Show new values panel": "Panel mit neuen Werten anzeigen",
    "New Values (CSV) — differences highlighted": "Neue Werte (CSV) — Unterschiede",
    "Importing...": "Wird importiert...",
    "Import": "Importieren",
    "/supplier-icons/suppliers": "/supplier-icons/suppliers",
    "Failed to load suppliers": "Fehler beim Laden von Lieferanten",
    "/supplier-icons/icons": "/supplier-icons/icons",
    "Failed to save icon": "Fehler beim Speichern des Icons",
    "Failed to upload icon": "Fehler beim Hochladen des Icons",
    "Are you sure you want to delete this supplier icon?": "Möchten Sie dieses Lieferanten-Icon wirklich löschen?",
    "Failed to delete icon": "Fehler beim Löschen des Icons",
    "Loading suppliers...": "Lieferanten werden geladen...",
    "Supplier Icons": "Lieferanten-Icons",
    "Assign icons to each supplier": "Jedem Lieferanten ein Icon zuordnen",
    "Select icon...": "Icon auswählen...",
    "No icon": "Kein Icon",
    "Change Icon": "Icon ändern",
    "Add Icon": "Icon hinzufügen",
    "Delete Icon": "Icon löschen",
    "/lock-properties": "/lock-properties",
    "Failed to load lock properties": "Fehler beim Laden von Eigenschaften",
    "/lock-properties/icons": "/lock-properties/icons",
    "/system-options/available-columns": "/system-options/available-columns",
    "Cannot delete icon. It is still used by:": "Icon kann nicht gelöscht werden. Es wird noch verwendet von:",
    "Maximum": "Maximal",
    "active properties allowed!": "aktive Eigenschaften erlaubt!",
    "Failed to save property": "Eigenschaft konnte nicht gespeichert werden",
    "New Property": "Neue Eigenschaft",
    "Failed to add lock property": "Fehler beim Hinzufügen der Eigenschaft",
    "Are you sure you want to delete this property?": "Möchten Sie diese Eigenschaft wirklich löschen?",
    "Failed to delete lock property": "Fehler beim Löschen der Eigenschaft",
    "Loading...": "Wird geladen...",
    "Lock Properties Management": "Eigenschaften",
    "Active properties:": "Aktive Eigenschaften:",
    "(displayed on page 2)": "(auf Seite 2 angezeigt)",
    "Add Property": "Eigenschaft hinzufügen",
    "Name:": "Name:",
    "Property name": "Name der Eigenschaft",
    "Property Code:": "Eigenschaftscode:",
    "-- Select Property Code --": "-- Eigenschaftscode auswählen --",
    "Unique identifier for this property": "Eindeutige Kennung für diese Eigenschaft",
    "Description:": "Beschreibung:",
    "Description shown to users": "Beschreibung für Benutzer sichtbar",
    "Icon:": "Icon:",
    "-- Select Icon --": "-- Icon auswählen --",
    "Uploading...": "Wird hochgeladen...",
    "Upload New": "Neu hochladen",
    "Available Icons:": "Verfügbare Icons:",
    "Icon preview": "Icon-Vorschau",
    "Code:": "Code:",
    "Active": "Aktiv",
    "Inactive": "Inaktiv",
    "Icon uploaded successfully!": "Icon erfolgreich hochgeladen!",
    "/lock-types/available": "/lock-types/available",
    "/lock-types": "/lock-types",
    "Failed to load lock types": "Fehler beim Laden von Schlosstypen",
    "/lock-types/icons": "/lock-types/icons",
    "Icon uploaded successfully": "Icon erfolgreich hochgeladen",
    "Icon": "Icon",
    "deleted successfully": "erfolgreich gelöscht",
    "Failed to add lock type": "Fehler beim Hinzufügen des Zylindertyp",
    "Error": "Fehler",
    "Are you sure you want to delete this lock type?": "Sind Sie sicher, dass Sie diesen Zylindertyp löschen möchten?",
    "Failed to delete lock type": "Fehler beim Löschen des Zylindertyp",
    "Changes saved successfully!": "Änderungen erfolgreich gespeichert!",
    "Failed to save lock types": "Fehler beim Speichern von Schlosstypen",
    "Error: Failed to save lock types": "Fehler: Schlosstypen konnten nicht gespeichert werden",
    "Lock Types Management": "Zylindertypen",
    "Available Types from Database (click to add):": "Verfügbare Typen aus der Datenbank (zum Hinzufügen klicken):",
    "No lock types configured yet. Add types from the list above.": "Noch keine Zylindertyp konfiguriert",
    "Type Code (from database):": "Typcode (aus Datenbank):",
    "Display Name:": "Anzeigename:",
    "Display name (e.g., Doppelzylinder)": "Anzeigename (z.B., Doppelzylinder)",
    "/": "/",
    "/suppliers": "/suppliers",
    "Failed to save supplier": "Lieferanten speichern fehlgeschlagen",
    "New Supplier": "Neuer Lieferant",
    "Failed to add supplier": "Lieferanten hinzufügen fehlgeschlagen",
    "Are you sure you want to delete this supplier?": "Sind Sie sicher, dass Sie diesen Lieferanten löschen möchten?",
    "Failed to delete supplier": "Lieferanten löschen fehlgeschlagen",
    "Supplier Management": "Lieferanten",
    "Active suppliers:": "Aktive Lieferanten:",
    "(displayed on pages 2, 3, and 4)": "(auf den Seiten 2, 3 und 4 angezeigt)",
    "Add Supplier": "Lieferanten hinzufügen",
    "Supplier name": "Name des Lieferanten",
    "Configuration saved successfully!": "Konfiguration erfolgreich gespeichert!",
    "Failed to save configuration": "Konfiguration speichern fehlgeschlagen",
    "System Options Mapping": "Systemzuordnung",
    "Configure which lock properties are enabled for each system": "Konfigurieren Sie, welche Eigenschaften für jedes System aktiviert sind",
    "Systems": "Systeme",
    "Save Configuration": "Konfiguration speichern",
    "Enabled": "Aktiviert",
    "Disabled": "Deaktiviert",
    "Select a system from the list to configure its options": "Wählen Sie ein System aus der Liste, um dessen Optionen zu konfigurieren",
    "/system-options": "/system-options",
    "Failed to load current tax rate": "Fehler beim Laden des aktuellen Steuersatzes",
    "Please enter a valid number.": "Bitte geben Sie eine gültige Zahl ein.",
    "Tax rate must be between 0 and 100.": "Der Steuersatz muss zwischen 0 und 100 liegen.",
    "New rate is the same as current rate.": "Der neue Satz entspricht dem aktuellen Satz.",
    "Tax rate successfully updated to": "Steuersatz erfolgreich aktualisiert auf",
    "Failed to update tax rate": "Fehler beim Aktualisieren des Steuersatzes",
    "Loading tax rate...": "Steuersatz wird geladen...",
    "Tax Rate Management": "MwSt.-Satz",
    "Manage the global VAT/tax rate applied in the configurator.": "Verwalten Sie den globalen MwSt./Steuersatz, der im Konfigurator angewendet wird.",
    "Current Tax Rate": "Aktueller Steuersatz",
    "New Tax Rate (%)": "Neuer Steuersatz (%)",
    "e.g. 23": "z.B. 19",
    "Updating...": "Wird aktualisiert...",
    "Update Tax Rate": "Steuersatz aktualisieren",
    "/tax-rate": "/tax-rate",
    "/users": "/users",
    "/roles": "/roles",
    "Please confirm": "Bitte bestätigen",
    "OK": "OK",
    "Restore": "Wiederherstellen",
    "Drop a CSV file here or click to choose one": "CSV-Datei hierher ziehen oder klicken, um sie auszuwählen",
    "Drop another CSV file here or click to replace it": "Andere CSV-Datei hierher ziehen oder klicken, um sie zu ersetzen",
    "Release to upload the file": "Loslassen, um die Datei hochzuladen",
    "Only .csv files can be imported.": "Es können nur .csv-Dateien importiert werden.",
    "Choose the target table first - CSV columns are matched to its columns.": "Zuerst die Zieltabelle wählen - die CSV-Spalten werden ihren Spalten zugeordnet.",
    "File": "Datei",
    "{count} row": "{count} Zeile",
    "{count} rows": "{count} Zeilen",
    "Are you sure you want to import {rows} into table \"{table}\"? This cannot be undone.": "Möchten Sie wirklich {rows} in die Tabelle „{table}“ importieren? Dies kann nicht rückgängig gemacht werden.",
    "Import {rows}": "{rows} importieren",
    "{rows} imported successfully!": "{rows} erfolgreich importiert!",
    "File analyzed successfully. {rows} found.": "Datei erfolgreich analysiert. {rows} gefunden.",
    "Permanently delete all data from table \"{table}\"? This cannot be undone.": "Alle Daten aus der Tabelle „{table}“ endgültig löschen? Dies kann nicht rückgängig gemacht werden.",
    "Are you sure you want to delete the icon \"{name}\"?": "Sind Sie sicher, dass Sie das Icon „{name}“ löschen möchten?",
    "Are you sure you want to change the tax rate from {from}% to {to}%?": "Möchten Sie den Steuersatz wirklich von {from} % auf {to} % ändern?",
    "Are you sure you want to delete the user \"{name}\"?": "Sind Sie sicher, dass Sie den Benutzer „{name}“ löschen möchten?",
    "Mail delivery": "Mailversand",
    "Details": "Details",
    "Failed to load mail status": "Status des Mailversands konnte nicht geladen werden",
    "Send a test email to {to}?": "Testmail an {to} senden?",
    "Send test email": "Testmail senden",
    "Test email sent to {to}.": "Testmail an {to} gesendet.",
    "Test email failed": "Testmail fehlgeschlagen",
    "Emails with orders and inquiries from the configurator.": "E-Mails mit Bestellungen und Anfragen aus dem Konfigurator.",
    "Transport": "Versandweg",
    "Sender": "Absender",
    "Test recipient": "Testempfänger",
    "Test mode: emails to customers go to this address, internal emails go to their recipient with [TEST] in the subject.": "Testmodus: E-Mails an Kunden gehen an diese Adresse, interne E-Mails an den eigentlichen Empfänger mit [TEST] im Betreff.",
    "Reminders to": "Erinnerungen an",
    "Sign-in": "Anmeldung",
    "Certificate": "Zertifikat",
    "Client secret": "Client Secret",
    "configured": "eingerichtet",
    "not configured": "nicht eingerichtet",
    "Valid until": "Gültig bis",
    "{days} days left": "noch {days} Tage",
    "Sending...": "Wird gesendet...",
    "The test email goes to {to}.": "Die Testmail geht an {to}.",
    "Test emails are only available with Microsoft Graph.": "Testmails sind nur mit Microsoft Graph möglich.",
    "Microsoft Graph (sendMail)": "Microsoft Graph (sendMail)",
    "SMTP (old account)": "SMTP (altes Konto)",
    "Outbox - saved as file, not sent": "Outbox - als Datei gespeichert, nicht versendet",
    "Backup partly failed": "Sicherung teilweise fehlgeschlagen",
    "Are you sure you want to restore this MongoDB backup? All current configurations and carts will be overwritten!": "Diese MongoDB-Sicherung wirklich wiederherstellen? Alle aktuellen Konfigurationen und Warenkörbe werden überschrieben!",
    "SQLite: prices and panel data · MongoDB: configurations and carts": "SQLite: Preise und Panel-Daten · MongoDB: Konfigurationen und Warenkörbe",
    "Create backup": "Sicherung erstellen"
  }
};

export type TranslationKey = keyof typeof translations.en;
